(function () {
  var overlay, imgEl, prevBtn, nextBtn, counterEl;
  var images = [];
  var currentIndex = 0;
  var initializedGalleries = new WeakSet();

  function buildDOM() {
    if (document.getElementById('aico-lightbox')) return;

    overlay = document.createElement('div');
    overlay.id = 'aico-lightbox';
    overlay.className = 'aico-lightbox-overlay';
    overlay.innerHTML =
      '<button class="aico-lightbox-close" aria-label="Close">' +
        '<svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
      '</button>' +
      '<button class="aico-lightbox-arrow aico-lightbox-arrow--prev" aria-label="Previous">' +
        '<svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>' +
      '</button>' +
      '<img src="" alt="" />' +
      '<button class="aico-lightbox-arrow aico-lightbox-arrow--next" aria-label="Next">' +
        '<svg viewBox="0 0 24 24"><polyline points="9 6 15 12 9 18"/></svg>' +
      '</button>' +
      '<div class="aico-lightbox-counter"></div>';

    document.body.appendChild(overlay);

    imgEl = overlay.querySelector('img');
    prevBtn = overlay.querySelector('.aico-lightbox-arrow--prev');
    nextBtn = overlay.querySelector('.aico-lightbox-arrow--next');
    counterEl = overlay.querySelector('.aico-lightbox-counter');

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });
    overlay.querySelector('.aico-lightbox-close').addEventListener('click', close);
    prevBtn.addEventListener('click', function (e) { e.stopPropagation(); navigate(-1); });
    nextBtn.addEventListener('click', function (e) { e.stopPropagation(); navigate(1); });

    document.addEventListener('keydown', onKey);
  }

  function onKey(e) {
    if (!overlay || !overlay.classList.contains('is-active')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft') navigate(-1);
    if (e.key === 'ArrowRight') navigate(1);
  }

  function show(idx) {
    currentIndex = idx;
    imgEl.style.opacity = '0';
    imgEl.src = images[currentIndex];
    imgEl.onload = function () { imgEl.style.opacity = '1'; };
    counterEl.textContent = (currentIndex + 1) + ' / ' + images.length;
    prevBtn.style.display = currentIndex === 0 ? 'none' : '';
    nextBtn.style.display = currentIndex === images.length - 1 ? 'none' : '';
  }

  function navigate(dir) {
    var next = currentIndex + dir;
    if (next < 0 || next >= images.length) return;
    show(next);
  }

  function open(srcs, startIndex) {
    buildDOM();
    images = srcs;
    show(startIndex);
    overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  function initGallery(gallery) {
    if (initializedGalleries.has(gallery)) {
      console.log('[AicoLightbox] Gallery already initialized, skipping', gallery);
      return;
    }
    initializedGalleries.add(gallery);

    var imgs = gallery.querySelectorAll('img');
    console.log('[AicoLightbox] Initializing gallery with', imgs.length, 'images', gallery);

    imgs.forEach(function (img) {
      img.style.cursor = 'pointer';
      img.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('[AicoLightbox] Image clicked', img.src || img.getAttribute('data-src'));

        var allImgs = gallery.querySelectorAll('img');
        var srcs = [];
        var idx = 0;

        allImgs.forEach(function (el, i) {
          var src = el.getAttribute('data-src') || el.getAttribute('src') || '';
          if (src) {
            if (el === img) idx = srcs.length;
            srcs.push(src);
          }
        });

        console.log('[AicoLightbox] Opening lightbox, total images:', srcs.length, 'starting at:', idx);
        if (srcs.length > 0) open(srcs, idx);
      });
    });

    var anchors = gallery.querySelectorAll('a[data-fancybox], a[href]');
    anchors.forEach(function (a) {
      if (a.querySelector('img')) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
        });
      }
    });
  }

  window.AicoLightbox = {
    init: function (container) {
      if (!container) return;

      var galleries = typeof container === 'string'
        ? document.querySelectorAll(container)
        : [container];

      galleries.forEach(function (gallery) {
        initGallery(gallery);
      });
    }
  };

  function autoInit() {
    var galleries = document.querySelectorAll('.aico-image-gallery');
    console.log('[AicoLightbox] Auto-init: found', galleries.length, '.aico-image-gallery elements');
    galleries.forEach(function (gallery) {
      initGallery(gallery);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoInit);
  } else {
    autoInit();
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.classList && node.classList.contains('aico-image-gallery')) {
          console.log('[AicoLightbox] MutationObserver: new .aico-image-gallery detected');
          initGallery(node);
        }
        if (node.querySelectorAll) {
          var nested = node.querySelectorAll('.aico-image-gallery');
          nested.forEach(function (g) {
            console.log('[AicoLightbox] MutationObserver: nested .aico-image-gallery detected');
            initGallery(g);
          });
        }
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
